import React from 'react';
import { TwoFAInfo } from './2FAInfo';

export default {
  messageId: 'two-fa-enablement-admin',
  bannerTag: 'ACCOUNT_SEC_WARNING',
  descriptionComponent: (props) => (
    <TwoFAInfo
      {...props}
      linkTranslationId={'ACCOUNT_SEC_LINK_DESCRIPTION_ADMIN'}
      descriptionTranslationId={'ACCOUNT_SEC_DESCRIPTION_ADMIN'}
      linkHref={'/admin/org-settings/sso'}
    />
  ),
  type: 'account',
  additionalAttributes: [
    {
      name: 'endDate',
      requireTranslate: false,
    },
  ],
};
